import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  ref: "switchContainer"
};
const _hoisted_2 = {
  class: "thumbnail-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.refreshing || $props.dataList.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "switch-container"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.dataList, (o, j) => {
      return _openBlock(), _createBlock(_component_el_col, {
        xs: $props.dataList.length > 4 ? 8 : 24 / $props.dataList.length,
        sm: $props.dataList.length > 4 ? 6 : 24 / $props.dataList.length,
        key: j
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: _normalizeClass({
            'selected-state': $data.currentSelectedIndex == j && $data.showselectedState
          })
        }, [_createVNode(_component_el_image, {
          class: "thumbnail",
          src: o.smallimg,
          fit: "contain",
          onClick: $event => $options.onclickThumbnail(j)
        }, null, 8, ["src", "onClick"])], 2)])]),
        _: 2
      }, 1032, ["xs", "sm"]);
    }), 128))]),
    _: 1
  })) : _createCommentVNode("", true)], 512);
}